import { Button, toast, Tooltip } from "@kyan/ui";

import { tooltips } from "#/config/tooltips";
import { useCancelAllOrders } from "#/services/kyan/hooks/useCancelAllOrders";
import { usePositionsDrawerMarket } from "#/store/app/positionsDrawer/positionsDrawerMarket";
import { useOpenOrders } from "#/store/wallet/account/openOrders";
import { confirm } from "#/utils/modals/confirm";

export const CancelAllOrders: React.FC = () => {
  const { market } = usePositionsDrawerMarket();
  const { openOrders } = useOpenOrders();
  const { mutate, isPending } = useCancelAllOrders({
    onSuccess: () => {
      toast.success({ title: "All orders cancelled successfully!" });
    },
    onError: (error) => {
      toast.error({
        title: "Failed to cancel all orders",
        description: error.message,
      });
    },
  });
  const isLiquidated = openOrders.some((order) => order.isLiquidated);

  const handleCancelAll = () => {
    confirm({
      content: "Are you sure you want to cancel all orders?",
      cancelText: "No, keep them",
      confirmText: "Yes, cancel all",
      onConfirm: () => {
        mutate({ market: market.underlying });
      },
    });
  };

  if (isLiquidated) return null;

  return (
    <Tooltip content={tooltips.cancelAll}>
      <Button
        size="sm"
        variant="action"
        isLoading={isPending}
        disabled={!openOrders.length}
        onClick={handleCancelAll}
      >
        Cancel all
      </Button>
    </Tooltip>
  );
};
